import { Select } from 'antd';
import React from 'react';
import './style.less';

const index = (props) => {
  return (
    <Select
      showSearch
      allowClear
      placeholder="Please select"
      filterOption={(input, option) =>
        option.searchfrom
          ? option.searchfrom.toLowerCase().indexOf(input.toLowerCase()) >= 0
          : option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    />
  );
};

export default index;
